const CARD_ACCENTS = [
  ['var(--accent-red, #e01e26)', '#ffffff'],
  ['var(--accent-blue, #0097cf)', '#ffffff'],
  ['var(--accent-yellow, #eab000)', '#1a1917'],
  ['var(--accent-green, #34af51)', '#ffffff'],
  ['var(--accent-green, #34af51)', '#ffffff'],
  ['var(--accent-yellow, #eab000)', '#1a1917'],
  ['var(--accent-blue, #0097cf)', '#ffffff'],
  ['var(--accent-red, #e01e26)', '#ffffff'],
];

const wiredCards = new WeakSet();

function wireCardHover(card) {
  if (wiredCards.has(card)) return;
  wiredCards.add(card);

  const badge = card.querySelector('.product-badges__badge--price');
  const title = card.querySelector('[role="heading"]');

  const applyAccent = () => {
    const accent = card.style.getPropertyValue('--card-accent');
    const text = card.style.getPropertyValue('--card-accent-text');
    if (badge) {
      badge.style.backgroundColor = accent;
      badge.style.color = text;
    }
    if (title) {
      title.style.textDecoration = 'underline';
      title.style.textDecorationColor = accent;
      title.style.textDecorationThickness = '2px';
      title.style.textUnderlineOffset = '3px';
    }
  };

  const clearAccent = () => {
    if (badge) {
      badge.style.backgroundColor = '';
      badge.style.color = '';
    }
    if (title) {
      title.style.textDecoration = '';
      title.style.textDecorationColor = '';
      title.style.textDecorationThickness = '';
      title.style.textUnderlineOffset = '';
    }
  };

  card.addEventListener('pointerenter', applyAccent);
  card.addEventListener('pointerleave', clearAccent);
  card.addEventListener('focusin', applyAccent);
  card.addEventListener('focusout', (event) => {
    if (card.contains(event.relatedTarget)) return;
    clearAccent();
  });
}

function applyCardAccents() {
  document.querySelectorAll('.resource-list, .product-grid').forEach((container) => {
    const items = container.querySelectorAll(':scope > .resource-list__item, :scope > .product-grid__item');
    items.forEach((item, index) => {
      const card = item.querySelector('product-card');
      if (!card) return;
      const [accent, text] = CARD_ACCENTS[index % CARD_ACCENTS.length];
      card.style.setProperty('--card-accent', accent);
      card.style.setProperty('--card-accent-text', text);
      wireCardHover(card);
    });
  });
}

let scheduled = false;
function scheduleApplyCardAccents() {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => {
    scheduled = false;
    applyCardAccents();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applyCardAccents);
} else {
  applyCardAccents();
}

new MutationObserver(scheduleApplyCardAccents).observe(document.body, {
  childList: true,
  subtree: true,
});
